import { schema } from 'normalizr';
import learningCourseVariant from './learningCourseVariant';

const learningAttemptSchema = new schema.Entity('learningAttempts', {
  courseVariant: learningCourseVariant,
});

export default learningAttemptSchema;
